// Movement 3 of 4: accuracy + frustration check.
// Source: CogniPrint_Recalibration_Dev_Plan_v1.md §3.7 (REC-030).

import { ArrowRight } from 'lucide-react';

interface Props {
  question: string;
  chips: string[];
  chipSelections: string[];
  freeText: string | null;
  onToggleChip: (chip: string) => void;
  onFreeTextChange: (text: string) => void;
  onBack: () => void;
  onContinue: () => void;
}

export function AccuracyCheck({
  question,
  chips,
  chipSelections,
  freeText,
  onToggleChip,
  onFreeTextChange,
  onBack,
  onContinue,
}: Props) {
  return (
    <>
      <div className="text-[11px] uppercase tracking-wider text-gold-500 font-semibold mb-1">
        Movement 3 · Accuracy & Frustration Check
      </div>
      <h3 className="font-heading text-[17px] font-bold text-white mb-4 leading-snug">
        {question}
      </h3>
      <div className="flex flex-wrap gap-2 mb-4">
        {chips.map((chip) => {
          const selected = chipSelections.includes(chip);
          return (
            <button
              key={chip}
              onClick={() => onToggleChip(chip)}
              className="text-xs font-medium rounded-full transition-all duration-200"
              style={{
                padding: '8px 14px',
                background: selected ? 'rgba(108,92,231,0.18)' : 'rgba(255,255,255,0.03)',
                border: selected ? '1px solid rgba(108,92,231,0.5)' : '1px solid rgba(255,255,255,0.08)',
                color: selected ? '#A39BE0' : '#c0bdd4',
              }}
            >
              {chip}
            </button>
          );
        })}
      </div>
      <textarea
        placeholder="Anything specific? (optional but helpful)"
        value={freeText ?? ''}
        onChange={(e) => onFreeTextChange(e.target.value)}
        rows={3}
        className="w-full rounded-lg text-sm p-3 mb-5"
        style={{
          background: 'rgba(255,255,255,0.02)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: '#e1dfef',
          resize: 'none',
        }}
      />
      <div className="flex items-center justify-between">
        <button onClick={onBack} className="text-xs text-content-muted underline">
          Back
        </button>
        <button
          onClick={onContinue}
          className="rounded-lg font-semibold text-sm"
          style={{
            padding: '9px 18px',
            background: 'linear-gradient(135deg, #6C5CE7, #A39BE0)',
            color: '#fff',
          }}
        >
          Last step <ArrowRight size={14} className="inline ml-1" />
        </button>
      </div>
    </>
  );
}
